// ConnectedHorse. Mirrors data-component="connected-horse" from the
// approved HTML. Side card that shows the linked horse profile with
// three mini-data rows (Barn, Trainer, Primary vet).
//
// TODO(runtime): hydrate from services/horse-timeline summarize
// (confirmed service, no HTTP read endpoint yet). "Open horse
// profile" navigates to the Horses tab for the same horse.
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { HORSE_PORTRAIT_PLACEHOLDER } from '../../../data/mockData.js';
import type { ConnectedHorse as ConnectedHorseData } from '../mockData.js';

export interface ConnectedHorseProps {
  horse: ConnectedHorseData;
  customerId: string;
  portraitUrl?: string;
}

export function ConnectedHorse({
  horse,
  customerId,
  portraitUrl,
}: ConnectedHorseProps): ReactNode {
  const navigate = useNavigate();
  return (
    <section className="card" data-component="connected-horse">
      <div className="section-heading">
        <h3>Connected to {horse.name}</h3>
        <span>Horse profile</span>
      </div>
      <div className="connected-horse-media">
        <img
          src={portraitUrl ?? HORSE_PORTRAIT_PLACEHOLDER}
          alt={`Reference portrait for ${horse.name}`}
        />
        <div>
          <strong>{horse.name}</strong>
          <span>
            {horse.breed} &middot; {horse.discipline}
          </span>
          <small>{horse.summary}</small>
        </div>
      </div>
      <div className="horse-related">
        <div className="mini-data">
          <span>Barn</span>
          <strong>{horse.barn}</strong>
        </div>
        <div className="mini-data">
          <span>Trainer</span>
          <strong>{horse.trainer}</strong>
        </div>
        <div className="mini-data">
          <span>Primary vet</span>
          <strong>{horse.primaryVet}</strong>
        </div>
        <button
          type="button"
          className="text-btn"
          onClick={() => navigate(`/horses/${customerId}/${horse.id}`)}
        >
          Open horse profile &rarr;
        </button>
      </div>
    </section>
  );
}
